<ion-header>
  <ion-toolbar>
    <ion-title>{{ header }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" color="dark">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="searchable">
    <ion-searchbar
      debounce="0"
      placeholder="Пошук"
      i18n-placeholder="@@common.searchPlaceholder"
      (ionChange)="search($event.detail.value)"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content style="--padding-bottom: var(--ion-safe-area-bottom, 0px)">
  <ion-list>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col
          *ngFor="let item of visibleItems"
          class="ion-no-padding"
          size="12"
          [sizeMd]="12 / columns"
        >
          <ion-item
            button
            detail="false"
            lines="full"
            (click)="selectItem(item)"
          >
            <ion-label>
              <h2>{{ item.label }}</h2>
              <p *ngIf="item.note">
                <small>{{ item.note }}</small>
              </p>
              <p *ngIf="item.subLabel">{{ item.subLabel }}</p>
            </ion-label>
            <ion-icon
              *ngIf="item.value === selectedValue"
              slot="end"
              name="checkmark"
              color="primary"
            ></ion-icon>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-item *ngIf="!visibleItems.length" lines="none">
      <ion-label
        class="ion-text-center"
        color="medium"
        i18n="@@common.nothingFound"
        >Нічого не знайдено</ion-label
      >
    </ion-item>
  </ion-list>
</ion-content>
